module.exports = __webpack_public_path__ + "static/media/cerrar.e4c31f46.svg";